import { c as _c } from "react/compiler-runtime";
import { SlidersHorizontal, X } from 'lucide-react';
import { Button } from '@/components/common/button';
interface FloatingFilterButtonProps {
  onOpenDrawer: () => void;
  onClearFilters: () => void;
  activeFilterCount: number;
  hasModifiedFilters: boolean;
}
export function FloatingFilterButton(t0) {
  const $ = _c(12);
  const {
    onOpenDrawer,
    onClearFilters,
    activeFilterCount,
    hasModifiedFilters
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SlidersHorizontal className="size-5" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== activeFilterCount) {
    t2 = activeFilterCount > 0 && <span className="flex size-6 items-center justify-center rounded-full bg-primary-blue text-sm font-bold text-white">{activeFilterCount}</span>;
    $[1] = activeFilterCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onOpenDrawer || $[4] !== t2) {
    t3 = <Button className="flex shadow-lg" onClick={onOpenDrawer} size="lg">{t1}Filters{t2}</Button>;
    $[3] = onOpenDrawer;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== hasModifiedFilters || $[7] !== onClearFilters) {
    t4 = hasModifiedFilters && <Button variant="secondary" onClick={onClearFilters} size="lg">Clear<X className="size-4" /></Button>;
    $[6] = hasModifiedFilters;
    $[7] = onClearFilters;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="fixed bottom-6 left-1/2 z-50 flex -translate-x-1/2 gap-2 md:hidden">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}